import { useMemo } from "react";
import { Button } from "react-bootstrap";

import { CopyCodeTabs } from "../../../../components/CopyCodeTabs";
import { CustomModal } from "../../../../components/CustomModal";
import type { CodeProps } from "./";

interface CodeModalProps extends CodeProps {
  hideModal: () => void;
}

const CodeModal: React.FC<CodeModalProps> = ({
  hideModal,
  isStream,
  messages,
  model,
  seed,
  tools,
  cacheControl,
}) => {
  const messagesString = useMemo(() => {
    const arr = Object.values(messages).map(({ choices }) => choices);
    return JSON.stringify(arr, null, 2);
  }, [messages]);

  const footerButtons = () => (
    <Button
      className="btn btn-secondary btn-sm"
      size="sm"
      variant="secondary"
      onClick={hideModal}
    >
      Cancel
    </Button>
  );

  return (
    <CustomModal
      show={true}
      handleClose={hideModal}
      title="View code"
      footer={footerButtons()}
      size="lg"
    >
      <CopyCodeTabs
        isStream={isStream}
        messages={messagesString}
        model={model}
        seed={seed}
        tools={tools}
        cacheControl={cacheControl}
      />
    </CustomModal>
  );
};

export { CodeModal };
